import AdvocateNambiDetails from '../../components/about/advocates-details/nambi';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateNambiDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | Nambi Krishna Dwaipayan'>
      <NavigationMenu active='about' />
      <PageHeader
        title='Nambi Krishna Dwaipayan'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateNambiDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateNambiDetailsPage;

